/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {getFormDropdownOptions} from '../../helpers/formDropdownOptions';

function defineBlock(forms) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("submit form")
                .appendField(new Blockly.FieldDropdown(forms), "FORMSLUG");
            this.appendStatementInput('THEN').appendField('then');
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Reset a form or a screen in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let formSlug = block.getFieldValue('FORMSLUG');
            let formFields = formSlug.split("<<<>>>");
            let formDataGenyId = formFields[0];
            let pageId = formFields[1];

            let innerBlockCode = Blockly.JavaScript.statementToCode(block, 'THEN');
            let code = `
                actionsModule.executeActionWithCallback({
                    action: {
                        actionType: "save",
                        parameters: {
                            resetForm: false
                        }
                    },
                    formDataGenyId: "${formDataGenyId || pageId}",
                }, function() {
                    ${innerBlockCode}
                });\n`;

            return code;
        }
    }
}

const Submit = function (props) {
    let name = "snap_action_submit_V3";
    Submit.blockName = name;

    const forms = getFormDropdownOptions(props.context);
    Blockly.Blocks[name] = defineBlock(forms);

    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!forms.length) {
        return null;
    }

    return (
        <block type={name}></block>
    );
};

Submit.propTypes = {
    context: PropTypes.object.isRequired
};

export default Submit;
